import { Box } from "@mui/material";
import { ReactNode } from "react";
import { getCurrentAuth } from "../../Hooks/http-server";
import { Navigate } from "react-router-dom";
import { PageRoutes } from "../../Utils/constant";
import MainContainer from "../MainContainer";

const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const auth = getCurrentAuth();
  if (!auth.AccessToken) {
    return <Navigate to={PageRoutes.Login} />;
  }
  return <MainContainer>{children}</MainContainer>;
};
export default PrivateRoute;
